/* ============================================================================
 * main.js — Sovereign Nexus Ghost theme core JS
 *
 * No external dependencies. Vanilla DOM APIs only.
 * Compiled by Gulp into assets/built/source.js (uglified) and loaded
 * from default.hbs before {{ghost_foot}}.
 *
 * Constitutional basis: H-AX-01 (sovereignty — no external JS CDN),
 *                       I-AX-03 (privacy — no third-party scripts),
 *                       V-AX-01 (efficiency — minimal runtime).
 * ============================================================================ */

;(function () {
  'use strict'

  // ────────────────────────────────────────────────────────────────────
  // Navigation drawer (mobile hamburger)
  // ────────────────────────────────────────────────────────────────────
  const nav = document.querySelector('.sn-nav')
  const burger = nav && nav.querySelector('.sn-nav__burger')
  const drawer = nav && nav.querySelector('#sn-nav-drawer')

  if (nav && burger && drawer) {
    const openDrawer = function () {
      nav.setAttribute('data-drawer-open', 'true')
      burger.setAttribute('aria-expanded', 'true')
      burger.setAttribute('aria-label', 'Close menu')
      document.documentElement.classList.add('sn-nav-drawer-open')
    }

    const closeDrawer = function () {
      nav.setAttribute('data-drawer-open', 'false')
      burger.setAttribute('aria-expanded', 'false')
      burger.setAttribute('aria-label', 'Open menu')
      document.documentElement.classList.remove('sn-nav-drawer-open')
    }

    burger.addEventListener('click', function () {
      const isOpen = burger.getAttribute('aria-expanded') === 'true'
      if (isOpen) {
        closeDrawer()
      } else {
        openDrawer()
      }
    })

    // Close drawer when any nav link is activated (keeps state sane after
    // the user taps through to a new page).
    drawer.addEventListener('click', function (event) {
      const link = event.target.closest('a')
      if (link) {
        closeDrawer()
      }
    })

    // Escape closes the drawer and returns focus to the burger.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return
      const isOpen = burger.getAttribute('aria-expanded') === 'true'
      if (isOpen) {
        closeDrawer()
        burger.focus()
      }
    })
  }

  // ────────────────────────────────────────────────────────────────────
  // Mark the current page's nav item with aria-current="page"
  // Ghost's {{navigation}} helper adds .nav-current to the active <li>;
  // we mirror that onto the <a> for ARIA correctness.
  // ────────────────────────────────────────────────────────────────────
  const currentNavItem = document.querySelector('.sn-nav__list .nav-current > a')
  if (currentNavItem) {
    currentNavItem.setAttribute('aria-current', 'page')
  }

  // ────────────────────────────────────────────────────────────────────
  // Citation copy-to-clipboard
  // Invoked by <button data-sn-copy-citation> inside the .sn-citation panel.
  // Reads the plain-text version of the sibling <p data-sn-citation-text>
  // and writes it to the clipboard. Flashes "Copied" for 2 seconds.
  // ────────────────────────────────────────────────────────────────────
  const copyButtons = document.querySelectorAll('[data-sn-copy-citation]')
  copyButtons.forEach(function (button) {
    const citation = button.closest('.sn-citation')
    if (!citation) return
    const textEl = citation.querySelector('[data-sn-citation-text]')
    const liveEl = citation.querySelector('.sn-citation__live')
    const label = button.querySelector('.sn-citation__copy-text') || button
    if (!textEl) return

    button.addEventListener('click', function () {
      const text = textEl.innerText.replace(/\s+/g, ' ').trim()
      if (!navigator.clipboard) return
      navigator.clipboard
        .writeText(text)
        .then(function () {
          const original = label.textContent
          label.textContent = 'Copied'
          button.setAttribute('data-state', 'copied')
          button.classList.add('sn-citation__copy--copied')
          if (liveEl) liveEl.textContent = 'Citation copied to clipboard.'
          setTimeout(function () {
            label.textContent = original
            button.removeAttribute('data-state')
            button.classList.remove('sn-citation__copy--copied')
            if (liveEl) liveEl.textContent = ''
          }, 2000)
        })
        .catch(function () {
          if (liveEl) liveEl.textContent = 'Copy failed. Select and copy manually.'
        })
    })
  })
})()
